import moment from 'moment/moment';
import 'moment/locale/es';

// Único lugar donde se define cuánto tarda la preparación: antes estaba
// duplicado (y desincronizado) entre la página de producto y el checkout,
// mostrando fechas de entrega distintas para la misma compra.
export const DIAS_PREPARACION = 1;

export const sumarDiasHabiles = (fecha: moment.Moment, dias: number): moment.Moment => {
  const resultado = fecha.clone();
  let agregados = 0;
  while (agregados < dias) {
    resultado.add(1, 'days');
    const dia = resultado.day();
    if (dia !== 0 && dia !== 6) {
      agregados++;
    }
  }
  return resultado;
};

export const getFechaEntregaEstimada = (): moment.Moment =>
  sumarDiasHabiles(moment(), DIAS_PREPARACION);
